import React, { useRef } from 'react';
import { useIntl } from 'react-intl';

import MagicWandFrap from 'shared/app/components/magic-wand-frap';
import { usePdpContext } from '../../pdp-provider';
import { filterDeselectedOptions } from '../../pdp-provider/use-clear-deselected-options/clear-deselected-options';
import ResetRecipeButton from '../reset-recipe-button';
import messages from './messages';

const CallsToAction = () => {
  const { formatMessage } = useIntl();
  const doneCustomizingButtonRef = useRef(null);

  const { selectedOptions, setIsCustomizing } = usePdpContext();
  const filteredSelectedOptions = filterDeselectedOptions(selectedOptions);
  const clickHandler = () => {
    setIsCustomizing(false);
  };

  return (
    <div className="flex flex-column items-center pt6">
      <MagicWandFrap
        message={formatMessage(messages.doneCustomizingLabel)}
        onClick={clickHandler}
        ref={doneCustomizingButtonRef}
      />
      {filteredSelectedOptions?.length ? (
        <div className="pt6">
          <ResetRecipeButton onResetRecipeRef={doneCustomizingButtonRef} />
        </div>
      ) : null}
    </div>
  );
};

export default CallsToAction;
